import { create } from 'zustand';
import { TFilter, TFilterStore } from './FilterStore.types';

export const filterInitialState: TFilter = {
	searchInput: '',
	carStatus: [],
	carTipo: [],
	brand: [],
	price: [0, 500_000],
	transmission: [],
	fuelType: [],
	dealerGroup: 0,
	sort: {
		value: 'default',
		label: 'Ordenação Padrão',
	},
	encerrandoHoje: false,
	importState: [],
};

export const useFilterStore = create<TFilterStore>((set, get) => ({
	filter: filterInitialState,

	isFilterActive: () => {
		const { filter } = get();
		const {
			searchInput,
			carStatus,
			brand,
			price,
			transmission,
			fuelType,
			dealerGroup,
			encerrandoHoje,
			importState,
			carTipo
		} = filter;

		return (
			searchInput !== '' ||
			carStatus.length > 0 ||
			carTipo.length > 0 ||
			brand.length > 0 ||
			price[0] !== 0 ||
			price[1] !== 500_000 ||
			transmission.length > 0 ||
			fuelType.length > 0 ||
			dealerGroup !== 0 ||
			encerrandoHoje ||
			importState.length > 0 
		);
	},

	resetFilter: () => set({ filter: filterInitialState }),

	setSearchInput: (searchInput: string) =>
		set((state) => ({ filter: { ...state.filter, searchInput } })),

	checkField: (field: keyof TFilter, values: string[]) =>
		set((state) => ({
			filter: {
				...state.filter,
				[field]: values,
			},
		})),

	setPrice: (price: number[]) => set((state) => ({ filter: { ...state.filter, price } })),

	setDealerGroup: (dealerGroupId: number) =>
		set((state) => ({
			filter: {
				...filterInitialState,
				dealerGroup: dealerGroupId === state.filter.dealerGroup ? 0 : dealerGroupId,
			},
		})),

	setSort: (option: TFilter['sort']) =>
		set((state) => ({
			filter: {
				...state.filter,
				sort: option,
			},
		})),

	setEncerrandoHoje: () =>
		set((state) => ({
			filter: {
				...filterInitialState,
				encerrandoHoje: !state.filter.encerrandoHoje,
			},
		})),

	setOfertasAtivas: () =>
		set(() => ({
			filter: {
				...filterInitialState,
				carStatus: ['0'],
			},
		})),


		setTipoAnuncio: () =>
		set(() => ({
			filter: {
				...filterInitialState,
				carTipo: ['0'],
			},
		})),

		setImportState: (states: string[]) => 
			set((state) => ({
				filter: {
					...state.filter,
					importState: states,
				},
			})),
}));
